import { createContext } from "react";
import { EMPTY_GUID } from "../../ExpressionsModule/Runtime/Evaluators/DomainServices/EMPTY_GUID";
import { BundleSettingsModel } from "../Models/BundleSettingsModel";
import { BundleThemeModel } from "../Models/BundleThemeModel";
import { EmbeddedResourceModel } from "../Models/EmbeddedResourceModel";
import { EnumModel } from "../Models/EnumModel";
import { ReactBundleModel } from "../Models/ReactBundleModel";
import { SharedComponentModel } from "../Models/SharedComponentModel";
import { ViewModel } from "../Models/ViewModel";

export interface IBundleContext {
  Id?: string;
  Views: ViewModel[];
  ViewById: Record<string, ViewModel>;
  EnumById: Record<string, EnumModel>;
  SharedComponentById: Record<string, SharedComponentModel>;
  ReactBundle?: ReactBundleModel;
  Theme?: Record<string, any>;
  Themes: BundleThemeModel[];
  SelectedThemeId?: string;
  SetSelectedThemeId: (themeId: string) => void;
  Settings?: BundleSettingsModel;
  EmbeddedResourceById: Record<string, EmbeddedResourceModel>;
  Refresh: () => Promise<void>;
  CurrentAppName?: string;
  AvailableApps?: string[];
  SetCurrentApp?: (name: string) => void;
}

const BundleContext = createContext<IBundleContext>({
  Id: EMPTY_GUID,
  Views: [],
  ViewById: {},
  EnumById: {},
  SharedComponentById: {},
  Themes: [],
  SetSelectedThemeId: () => {},
  EmbeddedResourceById: {},
  Refresh: async () => {},
  CurrentAppName: undefined,
  AvailableApps: [],
  SetCurrentApp: () => {},
});
export default BundleContext;
